<mat-card-header class="layout-row gap-5percent header">
  <fa-icon class="main-icon" icon="user" size="3x"></fa-icon>
  <mat-card-title-group>
    <div class="mat-typography">
      <mat-card-title>
        <h2>
          {{ employeeData.displayName }}
          <span [className]="employeeData.isActive === true ? 'true' : 'false'">
            <fa-icon
              matTooltip="{{ employeeData.isActive === true ? 'Active' : 'Inactive' }}"
              matTooltipPosition="right"
              icon="circle"
              size="lg"
            ></fa-icon>
          </span>
        </h2>
      </mat-card-title>
      <mat-card-subtitle>
        <p>{{ 'labels.inputs.Associated Office' | translate }}: {{ employeeData.officeName }}</p>
      </mat-card-subtitle>
    </div>
  </mat-card-title-group>
</mat-card-header>

<mat-card-content>
  <div class="layout-row-wrap">
    <div class="flex-50 mat-body-strong">
      {{ 'labels.inputs.Joined On' | translate }}
    </div>

    <div class="flex-50">
      {{ employeeData.joiningDate | dateFormat }}
    </div>

    <div class="flex-50 mat-body-strong">
      {{ 'labels.inputs.Loan Officer' | translate }}
    </div>

    <div class="flex-50">
      {{ employeeData.isLoanOfficer | yesNo }}
    </div>

    @if (employeeData.mobileNo) {
      <div class="flex-50 mat-body-strong">
        {{ 'labels.inputs.Mobile Number' | translate }}
      </div>
    }

    @if (employeeData.mobileNo) {
      <div class="flex-50">
        {{ employeeData.mobileNo }}
      </div>
    }

    <div class="flex-50 mat-body-strong">
      {{ 'labels.inputs.Number of Centers' | translate }}
    </div>

    <div class="flex-50">
      {{ centerData ? centerData.length : '' }}
    </div>
  </div>
</mat-card-content>
